import QuestionType from '@/models/Questions/QuestionType';

export default class QuestionTypeViewModel {
    name: string;
    value: QuestionType;

public constructor(name: string, value: QuestionType) {
        this.name = name;
        this.value = value;
    }
}